import { LoaderSpin } from '@framework/ui/components/loader/LoaderSpin.tsx';
import {
  type IDetectedBarcode,
  Scanner as ScannerHandler,
} from '@yudiel/react-qr-scanner';
import { Alert } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IScannerProps {
  onScan: (detectedCodes: IDetectedBarcode[]) => void;
  showInfo?: boolean;
}

export default function Scanner(props: IScannerProps) {
  const { onScan, showInfo } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Effettuiamo un controllo iniziale per verificare la presenza di una camera
  // con gestione di caricamento e errori
  useEffect(() => {
    const initCamera = async () => {
      try {
        const allDevices = await navigator.mediaDevices.enumerateDevices();
        const cams = allDevices.filter(d => d.kind === 'videoinput');

        // Gestiamo il caso in cui non ci siano camere
        if (cams.length === 0 || !cams[0].deviceId) {
          setError(
            t(
              'scanner-qr.permission-denied',
              'verificare di avere i permessi o che il dispositivo abbia una camera funzionante',
            ),
          );
        }

        setLoading(false);
      } catch (err: any) {
        console.error(err);
        setLoading(false);
        setError(err);
      }
    };

    initCamera();
  }, [t]);

  if (loading) {
    return <LoaderSpin />;
  }

  if (error) {
    return (
      <Alert
        showIcon
        type="warning"
        style={{
          marginBottom: 30,
          textAlign: 'center',
          maxWidth: '80%',
          margin: '0 auto 30px auto',
        }}
        message={t(
          'scanner-qr.camera-error',
          "Si è verificato un errore durante l'accesso alla camera: {{error}}",
          { error },
        )}
      />
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '250px',
      }}
    >
      {!showInfo && (
        <ScannerHandler
          onScan={onScan}
          styles={{
            container: {
              width: '350px',
              height: '280px',
              margin: '0 auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '12px',
              overflow: 'hidden',
              background: '#000',
            },
            video: {
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            },
          }}
        />
      )}
    </div>
  );
}
